import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-50694212"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "locomotive",
  fill: "none",
  height: "74",
  viewBox: "0 0 180 74",
  width: "180",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = {
  key: 0,
  id: "middle"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  fill: "#E5E5E5",
  height: "74",
  width: "180"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  fill: "white",
  height: "1504",
  transform: "translate(-1530 -566)",
  width: "2086"
}, null, -1))
const _hoisted_5 = {
  fill: "#333333",
  "font-family": "Inter",
  "font-size": "10",
  "font-weight": "bold",
  "letter-spacing": "0em",
  style: {"white-space":"pre"},
  "xml:space": "preserve"
}
const _hoisted_6 = {
  x: "19.4972",
  y: "20.7589"
}
const _hoisted_7 = {
  fill: "#333333",
  "font-family": "Inter",
  "font-size": "10",
  "font-weight": "bold",
  "letter-spacing": "0em",
  style: {"white-space":"pre"},
  "xml:space": "preserve"
}
const _hoisted_8 = {
  x: "113.828",
  y: "61.6364"
}
const _hoisted_9 = ["fill"]
const _hoisted_10 = {
  fill: "#333333",
  "font-family": "Inter",
  "font-size": "14",
  "font-weight": "bold",
  "letter-spacing": "0em",
  style: {"white-space":"pre"},
  "xml:space": "preserve"
}
const _hoisted_11 = {
  "dominant-baseline": "middle",
  "text-anchor": "middle",
  x: "50%",
  y: "38.6909"
}
const _hoisted_12 = {
  key: 1,
  id: "once"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  class: "locomotive__background",
  fill: "#333333",
  height: "16",
  rx: "3",
  transform: "rotate(-90 10 70)",
  width: "66",
  x: "10",
  y: "70"
}, null, -1))
const _hoisted_14 = {
  fill: "#333333",
  "font-family": "Inter",
  "font-size": "10",
  "font-weight": "bold",
  "letter-spacing": "0em",
  style: {"white-space":"pre"},
  "xml:space": "preserve"
}
const _hoisted_15 = {
  x: "28.0138",
  y: "19.7589"
}
const _hoisted_16 = {
  fill: "#333333",
  "font-family": "Inter",
  "font-size": "10",
  "font-weight": "bold",
  "letter-spacing": "0em",
  style: {"white-space":"pre"},
  "xml:space": "preserve"
}
const _hoisted_17 = {
  x: "104.828",
  y: "60.6364"
}
const _hoisted_18 = ["fill"]
const _hoisted_19 = {
  fill: "#333333",
  "font-family": "Inter",
  "font-size": "14",
  "font-weight": "bold",
  "letter-spacing": "0em",
  style: {"white-space":"pre"},
  "xml:space": "preserve"
}
const _hoisted_20 = {
  "dominant-baseline": "middle",
  "text-anchor": "middle",
  x: "50%",
  y: "39.5909"
}
const _hoisted_21 = {
  key: 2,
  id: "start"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  class: "locomotive__background",
  fill: "#333333",
  height: "16",
  rx: "3",
  transform: "rotate(-90 10 70)",
  width: "66",
  x: "10",
  y: "70"
}, null, -1))
const _hoisted_23 = {
  fill: "#333333",
  "font-family": "Inter",
  "font-size": "10",
  "font-weight": "bold",
  "letter-spacing": "0em",
  style: {"white-space":"pre"},
  "xml:space": "preserve"
}
const _hoisted_24 = {
  x: "29.0138",
  y: "19.7589"
}
const _hoisted_25 = {
  fill: "#333333",
  "font-family": "Inter",
  "font-size": "10",
  "font-weight": "bold",
  "letter-spacing": "0em",
  style: {"white-space":"pre"},
  "xml:space": "preserve"
}
const _hoisted_26 = {
  x: "113.828",
  y: "61.6364"
}
const _hoisted_27 = ["fill"]
const _hoisted_28 = {
  fill: "#333333",
  "font-family": "Inter",
  "font-size": "14",
  "font-weight": "bold",
  "letter-spacing": "0em",
  style: {"white-space":"pre"},
  "xml:space": "preserve"
}
const _hoisted_29 = {
  "dominant-baseline": "middle",
  "text-anchor": "middle",
  x: "50%",
  y: "39.5909"
}
const _hoisted_30 = {
  key: 3,
  id: "end"
}
const _hoisted_31 = {
  fill: "#333333",
  "font-family": "Inter",
  "font-size": "10",
  "font-weight": "bold",
  "letter-spacing": "0em",
  style: {"white-space":"pre"},
  "xml:space": "preserve"
}
const _hoisted_32 = {
  x: "19.0138",
  y: "20.7589"
}
const _hoisted_33 = {
  fill: "#333333",
  "font-family": "Inter",
  "font-size": "10",
  "font-weight": "bold",
  "letter-spacing": "0em",
  style: {"white-space":"pre"},
  "xml:space": "preserve"
}
const _hoisted_34 = {
  x: "103.828",
  y: "60.6364"
}
const _hoisted_35 = ["fill"]
const _hoisted_36 = {
  fill: "#333333",
  "font-family": "Inter",
  "font-size": "14",
  "font-weight": "bold",
  "letter-spacing": "0em",
  style: {"white-space":"pre"},
  "xml:space": "preserve"
}
const _hoisted_37 = {
  "dominant-baseline": "middle",
  "text-anchor": "middle",
  x: "50%",
  y: "39.5909"
}
const _hoisted_38 = {
  key: 4,
  id: "add",
  style: {"cursor":"pointer"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "90",
  cy: "37",
  fill: "white",
  r: "13.5",
  stroke: "#333333",
  "stroke-width": "3",
  transform: "rotate(-90 90 37)"
}, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  fill: "#333333",
  height: "16",
  transform: "rotate(-90 82 39)",
  width: "4",
  x: "82",
  y: "39"
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  fill: "#333333",
  height: "16",
  width: "4",
  x: "88",
  y: "29"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_ctx.locomotiveType === 'middle')
      ? (_openBlock(), _createElementBlock("g", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("rect", {
            class: _normalizeClass(["locomotive__border", { 'locomotive__border--error': _ctx.locomotive?.plansToLeaveAt && _ctx.locomotive.sectionStatus !== 4 ? _ctx.moment().isAfter(_ctx.locomotive.plansToLeaveAt) : false }]),
            fill: "white",
            height: "176",
            stroke: "#333333",
            "stroke-width": "4",
            transform: "rotate(-90 2 72)",
            width: "70",
            x: "2",
            y: "72"
          }, null, 2),
          _createElementVNode("text", _hoisted_5, [
            _createElementVNode("tspan", _hoisted_6, _toDisplayString(_ctx.locomotive.sectionNumber), 1)
          ]),
          _createElementVNode("text", _hoisted_7, [
            _createElementVNode("tspan", _hoisted_8, _toDisplayString(_ctx.locomotive.locomotiveModel), 1)
          ]),
          _createElementVNode("circle", {
            cx: "90",
            cy: "37",
            fill: _ctx.fill,
            r: "13.5",
            stroke: "#333333",
            "stroke-width": "3"
          }, null, 8, _hoisted_9),
          _createElementVNode("text", _hoisted_10, [
            _createElementVNode("tspan", _hoisted_11, _toDisplayString(_ctx.locomotive.jobCategoryShort), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.locomotiveType === 'once')
      ? (_openBlock(), _createElementBlock("g", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("rect", {
            class: _normalizeClass(["locomotive__border", { 'locomotive__border--error': _ctx.locomotive?.plansToLeaveAt && _ctx.locomotive.sectionStatus !== 4 ? _ctx.moment().isAfter(_ctx.locomotive.plansToLeaveAt) : false }]),
            fill: "white",
            height: "156",
            rx: "13",
            stroke: "#333333",
            "stroke-width": "4",
            transform: "rotate(-90 12 72)",
            width: "70",
            x: "12",
            y: "72"
          }, null, 2),
          _createElementVNode("text", _hoisted_14, [
            _createElementVNode("tspan", _hoisted_15, _toDisplayString(_ctx.locomotive.sectionNumber), 1)
          ]),
          _createElementVNode("text", _hoisted_16, [
            _createElementVNode("tspan", _hoisted_17, _toDisplayString(_ctx.locomotive.locomotiveModel), 1)
          ]),
          _createElementVNode("circle", {
            cx: "90",
            cy: "37",
            fill: _ctx.fill,
            r: "13.5",
            stroke: "#333333",
            "stroke-width": "3"
          }, null, 8, _hoisted_18),
          _createElementVNode("text", _hoisted_19, [
            _createElementVNode("tspan", _hoisted_20, _toDisplayString(_ctx.locomotive.jobCategoryShort), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.locomotiveType === 'start')
      ? (_openBlock(), _createElementBlock("g", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("path", {
            class: _normalizeClass(["locomotive__border", { 'locomotive__border--error': _ctx.locomotive?.plansToLeaveAt && _ctx.locomotive.sectionStatus !== 4 ? _ctx.moment().isAfter(_ctx.locomotive.plansToLeaveAt) : false }]),
            d: "M12 59L12 15C12 7.8203 17.8203 2 25 2L178 1.99999L178 72L25 72C17.8203 72 12 66.1797 12 59Z",
            fill: "white",
            stroke: "#333333",
            "stroke-width": "4"
          }, null, 2),
          _createElementVNode("text", _hoisted_23, [
            _createElementVNode("tspan", _hoisted_24, _toDisplayString(_ctx.locomotive.sectionNumber), 1)
          ]),
          _createElementVNode("text", _hoisted_25, [
            _createElementVNode("tspan", _hoisted_26, _toDisplayString(_ctx.locomotive.locomotiveModel), 1)
          ]),
          _createElementVNode("circle", {
            cx: "90",
            cy: "37",
            fill: _ctx.fill,
            r: "13.5",
            stroke: "#333333",
            "stroke-width": "3"
          }, null, 8, _hoisted_27),
          _createElementVNode("text", _hoisted_28, [
            _createElementVNode("tspan", _hoisted_29, _toDisplayString(_ctx.locomotive.jobCategoryShort), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.locomotiveType === 'end')
      ? (_openBlock(), _createElementBlock("g", _hoisted_30, [
          _createElementVNode("path", {
            class: _normalizeClass(["locomotive__border", { 'locomotive__border--error': _ctx.locomotive?.plansToLeaveAt && _ctx.locomotive.sectionStatus !== 4 ? _ctx.moment().isAfter(_ctx.locomotive.plansToLeaveAt) : false }]),
            d: "M2 72L2 2L155 1.99999C162.18 1.99999 168 7.82029 168 15L168 59C168 66.1797 162.18 72 155 72L2 72Z",
            fill: "white",
            stroke: "#333333",
            "stroke-width": "4"
          }, null, 2),
          _createElementVNode("text", _hoisted_31, [
            _createElementVNode("tspan", _hoisted_32, _toDisplayString(_ctx.locomotive.sectionNumber), 1)
          ]),
          _createElementVNode("text", _hoisted_33, [
            _createElementVNode("tspan", _hoisted_34, _toDisplayString(_ctx.locomotive.locomotiveModel), 1)
          ]),
          _createElementVNode("circle", {
            cx: "90",
            cy: "37",
            fill: _ctx.fill,
            r: "13.5",
            stroke: "#333333",
            "stroke-width": "3"
          }, null, 8, _hoisted_35),
          _createElementVNode("text", _hoisted_36, [
            _createElementVNode("tspan", _hoisted_37, _toDisplayString(_ctx.locomotive.jobCategoryShort), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.locomotiveType === 'add')
      ? (_openBlock(), _createElementBlock("g", _hoisted_38, [
          _createElementVNode("rect", {
            class: _normalizeClass(["locomotive__border", { 'locomotive__border--error': _ctx.locomotive?.plansToLeaveAt && _ctx.locomotive.sectionStatus !== 4 ? _ctx.moment().isAfter(_ctx.locomotive.plansToLeaveAt) : false }]),
            fill: "white",
            height: "156",
            rx: "13",
            stroke: "#333333",
            "stroke-dasharray": "8 8",
            "stroke-width": "4",
            transform: "rotate(-90 12 72)",
            width: "70",
            x: "12",
            y: "72"
          }, null, 2),
          _hoisted_39,
          _hoisted_40,
          _hoisted_41
        ]))
      : _createCommentVNode("", true)
  ]))
}